/** Angular Imports */
import { NgModule } from '@angular/core';

/** Angular Font Awesome Imports */
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faAnchor,
  faArchive,
  faArrowLeft,
  faArrowRight,
  faBars,
  faBell,
  faBook,
  faBriefcase,
  faBuilding,
  faCalendar,
  faCalendarAlt,
  faChartBar,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faHeartBroken,
  faClock,
  faCloud,
  faCog,
  faCogs,
  faCommentAlt,
  faDollarSign,
  faEdit,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileUpload,
  faFileWord,
  faFillDrip,
  faHandHoldingUsd,
  faHome,
  faKey,
  faLink,
  faList,
  faListUl,
  faLocationArrow,
  faLock,
  faLockOpen,
  faMinusCircle,
  faMinus,
  faMoneyBillAlt,
  faMoneyCheck,
  faPencilAlt,
  faPlay,
  faPlus,
  faPlusCircle,
  faQuestionCircle,
  faRandom,
  faRoad,
  faSearch,
  faShieldAlt,
  faSignOutAlt,
  faSitemap,
  faSync,
  faTable,
  faTachometerAlt,
  faTag,
  faTags,
  faTimesCircle,
  faTrash,
  faUndo,
  faUniversity,
  faUserCircle,
  faUser,
  faUsers,
  faUserShield,
  faUserTie,
  faDownload,
  faUpload,
  faCloudDownloadAlt,
  faCloudUploadAlt,
  faTimes,
  faStickyNote,
  faStop,
  faBan,
  faBolt,
  faLaptop,
  faDonate,
  faMoneyBill,
  faChartLine,
  faPen,
  faFlag,
  faArrowUp,
  faArrowDown,
  faFolderOpen,
  faIdBadge,
  faAddressCard,
  faKeyboard,
  faInfo,
  faTasks,
  faCoins,
  faPiggyBank
} from '@fortawesome/free-solid-svg-icons';

/**
 * Icons Module
 *
 * Angular Font Awesome module is exported here.
 */
@NgModule({
  exports: [FontAwesomeModule]
})
export class IconsModule {

  constructor(library: FaIconLibrary) {
    library.addIcons(
      faAnchor,
      faArchive,
      faArrowLeft,
      faArrowRight,
      faBars,
      faBell,
      faBook,
      faBriefcase,
      faBuilding,
      faCalendar,
      faCalendarAlt,
      faChartBar,
      faCheck,
      faCheckCircle,
      faChevronDown,
      faChevronLeft,
      faChevronRight,
      faCircle,
      faHeartBroken,
      faClock,
      faCloud,
      faCog,
      faCogs,
      faCommentAlt,
      faDollarSign,
      faEdit,
      faEnvelope,
      faExclamationCircle,
      faExclamationTriangle,
      faEye,
      faEyeSlash,
      faFile,
      faFileAlt,
      faFileUpload,
      faFileWord,
      faFillDrip,
      faHandHoldingUsd,
      faHome,
      faKey,
      faLink,
      faList,
      faListUl,
      faLocationArrow,
      faLock,
      faLockOpen,
      faMinus,
      faMinusCircle,
      faMoneyBillAlt,
      faMoneyCheck,
      faPencilAlt,
      faPlay,
      faPlus,
      faPlusCircle,
      faQuestionCircle,
      faRandom,
      faRoad,
      faSearch,
      faShieldAlt,
      faSignOutAlt,
      faSitemap,
      faSync,
      faTable,
      faTachometerAlt,
      faTag,
      faTags,
      faTimesCircle,
      faTrash,
      faUndo,
      faUniversity,
      faUserCircle,
      faUser,
      faUsers,
      faUserShield,
      faUserTie,
      faDownload,
      faUpload,
      faCloudDownloadAlt,
      faCloudUploadAlt,
      faTimes,
      faStickyNote,
      faStop,
      faBan,
      faBolt,
      faLaptop,
      faDonate,
      faMoneyBill,
      faChartLine,
      faPen,
      faFlag,
      faArrowUp,
      faArrowDown,
      faFolderOpen,
      faIdBadge,
      faAddressCard,
      faKeyboard,
      faInfo,
      faTasks,
      faCoins,
      faPiggyBank
    );
  }

}
